import { transparentize } from 'polished'

import { Colors } from 'theme/constants'

export const getBoxShadow = () =>
  `0px 24px 64px 0px ${transparentize(0.95, Colors.brand.black)}`
